import React from 'react';
import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import routes from 'store/configs/Routes';

interface LegalLinksProps {
  className?: string;
  color?: 'primary' | 'secondary' | 'inherit';
}

const LegalLinks: React.FunctionComponent<LegalLinksProps> = ({ className, color }) => (
  <>
    <Link href={'https://www.nccer.org/terms-conditions/'} color={color} target={'_blank'} className={className}>
      {'Terms & Conditions - NCCER'}
    </Link>
    <Link href={'https://www.nccer.org/privacy-policy/'} color={color} target={'_blank'} className={className}>
      {'Privacy Policy - NCCER'}
    </Link>
    <Link component={RouterLink} to={routes.accessibilityStatement} color={color} className={className}>
      {'Accessibility Statement - NCCER'}
    </Link>
  </>
);
export default LegalLinks;
